import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { Loader2, Calendar, Users, ArrowRight } from "lucide-react";

export default function SpecialIssuesPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/special-issues").then(({ data }) => setItems(data)).finally(() => setLoading(false)); }, []);

  return (
    <div>
      <PageHeader eyebrow="Call for Papers" title="Special Issues" subtitle="Thematic collections curated by guest editors. Submit your research to an open special issue." breadcrumb="Special Issues" />

      <section className="max-w-7xl mx-auto px-6 py-12">
        {loading ? (
          <div className="py-20 grid place-items-center"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>
        ) : items.length === 0 ? (
          <p className="text-center text-slate-500 py-20">No open special issues right now. Please check back soon.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {items.map((s) => (
              <div key={s.id} data-testid={`special-${s.id}`} className="bg-card rounded-xl border border-slate-200 dark:border-slate-800 overflow-hidden hover:shadow-md transition-all flex flex-col">
                <div className="h-32 w-full bg-slate-100 dark:bg-slate-800 overflow-hidden">
                  {s.journal?.cover_image && <img src={s.journal.cover_image} alt={s.journal.title} className="w-full h-full object-cover" loading="lazy" />}
                </div>
                <div className="p-6 flex flex-col flex-1">
                <div className="flex items-center gap-2 text-xs text-amber-600 font-semibold uppercase tracking-wider mb-3">
                  <Calendar className="w-4 h-4" /> Submission due {s.due_date}
                </div>
                <h3 className="font-serif font-bold text-xl text-slate-900 dark:text-slate-100 leading-snug">{s.title}</h3>
                <p className="text-sm text-slate-600 dark:text-slate-400 mt-3 flex-1">{s.description}</p>
                {s.guest_editors?.length > 0 && (
                  <p className="text-sm text-slate-500 mt-4 flex items-center gap-2"><Users className="w-4 h-4" /> Guest Editors: {s.guest_editors.join(", ")}</p>
                )}
                <div className="flex items-center justify-between mt-5 pt-4 border-t border-slate-100 dark:border-slate-800">
                  {s.journal && <Link to={`/journal/${s.journal.slug}`} className="text-sm italic text-primary dark:text-sky-400 hover:underline">{s.journal.title}</Link>}
                  <Button asChild size="sm" className="rounded-full"><Link to="/submit">Submit <ArrowRight className="w-3.5 h-3.5 ml-1" /></Link></Button>
                </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
